
import FormInputDash from "@/components/main/forms/FormInputDash";
import {email,minLength, required} from "vuelidate/lib/validators";
import DashModal from "@/components/dashboard/DashModal";
import "@/plugins/vuelidate"
import validationErrors from "@/mixins/validationErrors";

export default {
  name: "FeedBack",
  mixins: [validationErrors],
  props: ['title'],
  components: {FormInputDash, DashModal},
  validations: {
    form: {
      first_name: {required, minLength: minLength(3)},
      last_name: {required, minLength: minLength(3)},
      email: {required, email},
    }
  },
  data() {
    return {
      form: {
        first_name: '',
        last_name: '',
        email: '',
        message: '',
        subject: 'FeedbackForm',
      },
      captchaChecked: false,
      captchaResponse: null,
    }
  },

  computed: {
    someFormErrors() {
      return this.$v.form.first_name.$error
        || this.$v.form.last_name.$error
        || this.$v.form.email.$error
        || this.form.message.length < 3
        || !this.captchaChecked
    }
  },

  methods: {
    async submit() {
      this.captchaResponse = await this.$recaptcha.getResponse();
      let self = this;
      this.$axios.setHeader('Authorization', `bearer ${localStorage.getItem('token')}`, ['post']);
      this.$axios.post(process.env.API_BASE_URL + '/api/contact', {
        first_name: this.form.first_name,
        last_name: this.form.last_name,
        email: this.form.email,
        message: this.form.message,
        subject: this.form.subject,
        'g-recaptcha-response': this.captchaResponse,
      }, {})
        .then(function (response) {
          self.form.first_name = ''
          self.$v.form.first_name.$reset()
          self.form.last_name = ''
          self.$v.form.last_name.$reset()
          self.form.email = ''
          self.$v.form.email.$reset()
          self.form.message = ''

          self.$notify({
            group: 'main',
            title: 'Success',
            text: response.data.message,
            type: 'success',
            speed: 1000,
            duration: 10000,
          });
        })
        .catch(function (error) {
          if (error.response && (error.response.status === 422 || error.response.status === 429)) {
            self.displayValidationErrors(error.response);
          } else {
            console.error(error);
          }
        })
        .finally(function () {
          self.refreshCaptcha();
        })
    },

    changeCaptchaChecked() {
      this.captchaChecked = true;
    },
    onExpired() {
      this.captchaChecked = false;
    },
    refreshCaptcha() {
      this.$recaptcha.reset();
      this.captchaChecked = false;
      this.captchaResponse = null;
    },
  }
}
